import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-translate-renderer',
  template: `
    <div>{{ content | translate }}</div>
  `,
  standalone: false
})
export class AtlasGridTranslateRendererComponent implements ICellRendererAngularComp {
  params;
  content: string;

  agInit(params): void {
    this.params = params;
    this.content = this.params.content(params) || null;
  }

  refresh(params: any): boolean {
    return false;
  }
}
